import script from "./AdminServiceList.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminServiceList.vue?vue&type=script&setup=true&lang=js"

import "./AdminServiceList.vue?vue&type=style&index=0&id=4fd9914b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fd9914b"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QSpinnerGears from 'quasar/src/components/spinner/QSpinnerGears.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QPageSticky from 'quasar/src/components/page-sticky/QPageSticky.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QBtn,QSkeleton,QIcon,QCard,QBadge,QImg,QSpinnerGears,QCardSection,QPagination,QPageSticky});
